import { Heading, Text, VStack } from "@chakra-ui/react";
import React from "react";

const Card = ({service,index}) => {
  return (
    <>
      <VStack
        key={index}
        bgImage={`url(${service.image})`}
        bgSize="cover"
        bgPosition="center"
        p={6}
        borderRadius="md"
        color="white"
        textAlign="center"
        height="370px"
        width="320px"
        justifyContent="center"
        marginTop={{base:'0',md:index === 1 ? '48px' : 8}}
        // my={{base:8,md:8}}
      
      >
        <Heading fontSize="lg">{service.title}</Heading>
        <Text fontSize="sm">{service?.sorttitle}</Text>
        <Text fontSize="sm">{service.description}</Text>
        <Text fontSize="sm">{service?.shortdescription}</Text>
      </VStack>
    </>
  );
};

export default Card;
